/**
 * Токен ожидания — единственное значение, которое геттер-генератор может отдать драйверу вычисления.
 *
 * Токен создается только внутри пакета и попадает в геттер через `yield*` по результату
 * `watchAsync` и его комбинаторов. Прикладной код сконструировать его не может, поэтому
 * `yield` голого промиса — ошибка типов и рантайма, а не молчаливое ожидание источника,
 * на который вычисление не подписано и по изменению которого не пересчитается.
 */
export class FlowAwait {
    private readonly promise: PromiseLike<unknown>;

    public constructor(promise: PromiseLike<unknown>) {
        this.promise = promise;
    }

    /**
     * Достает промис из токена ожидания.
     *
     * @param value - Значение, отданное геттером-генератором
     * @returns Промис, разрешения которого ждет драйвер
     * @throws {TypeError} Если отдан не токен ожидания
     */
    public static unwrap(value: unknown): PromiseLike<unknown> {
        if (!(value instanceof FlowAwait)) {
            throw new TypeError('Ждать в геттере можно только потоки: `yield* watchAsync(flow)`');
        }

        return value.promise;
    }
}
